import React from "react";

const Receipt = (props) => {
  const { attendees } = props;

  const ticketLevels = attendees.reduce((uniqueTicketLevels, attendee) => {
    const {
      ticket_level,
      ticket_level: { id },
    } = attendee;

    if (uniqueTicketLevels[id]) {
      uniqueTicketLevels[id].count++;
      return uniqueTicketLevels;
    } else {
      ticket_level.count = 1;
      uniqueTicketLevels[id] = ticket_level;
      return uniqueTicketLevels;
    }
  }, {});

  const total = Object.keys(ticketLevels).reduce(
    (obj, ticketLevel) => {
      const ticketCount = ticketLevels[ticketLevel].count;
      const ticketAmount = ticketLevels[ticketLevel].amount;

      if (ticketCount) {
        obj.count = obj.count + ticketCount;
        obj.amount = obj.amount + ticketAmount * ticketCount;
      } else {
        obj.count = ticketCount;
        obj.amount = ticketAmount;
      }
      return obj;
    },
    { count: 0, amount: 0 },
  );
  return (
    <div className="m-md-a">
      {Object.keys(ticketLevels).map((key) => (
        <div className="row" key={key}>
          <div className="col-xs-12">
            <h3 className="receipt-title">{ticketLevels[key]["name"]} tickets</h3>
          </div>
          <div className="col-xs-5">
            <div>Quantity</div>
            <span>{ticketLevels[key]["count"]}</span>
          </div>
          <div className="col-xs-3">
            <div>Price</div>
            <span>${ticketLevels[key]["amount"] || 0}</span>
          </div>
        </div>
      ))}
      <div className="row">
        <div className="col-xs-12">
          <h3 className="receipt-title">Total</h3>
        </div>
        <div className="col-xs-5">
          <div>Quantity</div>
          <span>{total["count"]}</span>
        </div>
        <div className="col-xs-3">
          <div>Price</div>
          <span>${total["amount"] || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
